import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {Icon, TextField, Typography} from '@material-ui/core';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {FuseAnimate} from '@fuse';

class CompanyHeader extends Component {

    componentDidMount() {
        let event = {target: {value: ''}};
        this.props.setSearchText(event);
    }

    render() {
        const {setSearchText, searchText} = this.props;
        return (
            <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                <div className="flex flex-1 items-center">
                    <div className="flex items-center">
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <Icon className="text-32 mr-12">business</Icon>
                        </FuseAnimate>
                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <Typography variant="title">公司列表</Typography>
                        </FuseAnimate>
                    </div>
                </div>

                <div className="flex items-center">

                    <FuseAnimate animation="transition.expandIn" delay={300}>
                        <Icon color="action">search</Icon>
                    </FuseAnimate>

                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                        <TextField
                            placeholder="搜尋"
                            className="pl-16"
                            fullWidth
                            value={searchText}
                            inputProps={{
                                'aria-label': 'Search'
                            }}
                            onChange={setSearchText}
                        />
                    </FuseAnimate>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    root: {}
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSearchText: ReduxGlobal.ActionCreator.setSearchText
    }, dispatch);
}

function mapStateToProps({global: {searchText}}) {
    return {searchText};
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(CompanyHeader));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/company/CompanyHeader.js